import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import Footer from '../pages/shared/Footer/Footer';
import Header from '../pages/shared/Header/Header';

const Main = () => {
    return (
        <div>
            
            <Container fluid>
            <Header ></Header>
                <Row>
                    <Outlet></Outlet>
                </Row>
            </Container>
            <Footer></Footer>
        </div>
    );
};

export default Main;